module.exports = __webpack_public_path__ + "static/media/nlp2.bda03926.png";